import { nullableSchema, objectSchema } from "vue-utils"
import { Nullable } from "../IncidentEntity"

export interface SearchPattern {
   commenceSearchPosition: Nullable<string>
   firstLegDirection: Nullable<string>
   firstTurn: Nullable<string>
   creepDirection: Nullable<string>
   legLength: Nullable<string>
   numberOfLegs: Nullable<number>
   trackSpacing: Nullable<string>
}

export const SearchPattern = objectSchema<SearchPattern>({
   commenceSearchPosition: nullableSchema(String),
   firstLegDirection: nullableSchema(String),
   firstTurn: nullableSchema(String),
   creepDirection: nullableSchema(String),
   legLength: nullableSchema(String),
   numberOfLegs: nullableSchema(Number),
   trackSpacing: nullableSchema(String),
})